import { fg } from '@confluence/feature-gating';
import { query, queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { TWCG_1489_CONNECTOR_ONBOARDING } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';
import {
	onboardingStateGetOnboardingStateQuery,
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from '@confluence/onboarding-helpers/entry-points/onboardingStateGetOnboardingStateQuery.ts';

import useConnectorOnboardingTeamTypeQuery, {
	type useConnectorOnboardingTeamTypeQuery$data,
	type useConnectorOnboardingTeamTypeQuery$variables,
} from './hooks/__generated__/useConnectorOnboardingTeamTypeQuery.graphql.ts';

export const preloadConnectorOnboardingState = (userId?: string) => {
	if (!fg('twcg-1489-cc-3p-connector-onboarding-fg')) {
		return Promise.resolve();
	}

	const tasks = [
		query<
			onboardingStateGetOnboardingStateQuery$data,
			onboardingStateGetOnboardingStateQuery$variables
		>({
			query: onboardingStateGetOnboardingStateQuery,
			variables: {
				key: Object.values(TWCG_1489_CONNECTOR_ONBOARDING),
			},
		}),
		...(userId
			? [
					queryAgg<
						useConnectorOnboardingTeamTypeQuery$data,
						useConnectorOnboardingTeamTypeQuery$variables
					>({
						query: useConnectorOnboardingTeamTypeQuery,
						variables: { userId },
					}),
				]
			: []),
	];

	return waitForAllReturnWhenError(tasks);
};
